module.exports = __webpack_public_path__ + "images/halloween_lp/sec01_title_a9043eab5135f03e138a2dd7b663d0e3.png";